<grid-list-view
  #gridlist
  [errorMsg]="errorMsg"
  [gridKeyColumn]="gridKeyColumn"
  [columnDefs]="sourceColumns"
  [frameworkComponents]="sourceComponents"
  [gridDelegate]="this"
  (saveEntity)="save($event)"
  (removeEntity)="remove($event)"
  (refreshView)="refreshView()"
>
</grid-list-view>
